/**
 * Channel Service 
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Online sku that has been saved or published online
 */
export interface OnlineSkuResVO { 
    /**
     * ID
     */
    id?: number;
    /**
     * Product ID
     */
    spuId?: number;
    /**
     * Product code
     */
    spuCode?: string;
    /**
     * Product name
     */
    spuName?: string;
    /**
     * Product type: 1 Physical, 2 Virtual
     */
    spuType?: number;
    /**
     * SKU ID
     */
    skuId?: number;
    /**
     * SKU code name
     */
    skuCode?: string;
    /**
     * SKU name
     */
    skuName?: string;
    /**
     * On-stock inventory
     */
    stockNum?: number;
    /**
     * Category name
     */
    categoryName?: string;
    /**
     * Warehouse type
     */
    typeCode?: string;
    /**
     * Brand name
     */
    brandName?: string;
    /**
     * Brand ID
     */
    brandId?: number;
    /**
     * Lock Number
     */
    lockNum?: number;
    /**
     * Preemption Number
     */
    preemptionNum?: number;
    /**
     * Reserved Number
     */
    reservedNum?: number;
    /**
     * Way Number
     */
    wayNum?: number;
    /**
     * Cost price
     */
    costPrice?: number;
    /**
     * Sales price
     */
    salesPrice?: number;
    /**
     * Activity price
     */
    activityPrice?: number;
    /**
     * Market price
     */
    marketPrice?: number;
    /**
     * Status
     */
    status?: OnlineSkuResVO.StatusEnum;
    /**
     * Quantity available on Lazada
     */
    lazadaQuantity?: number;
    /**
     * Sellable quantity on Lazada
     */
    lazadaSellableQuantity?: number;
}
export namespace OnlineSkuResVO {
    export const StatusEnum = {
        Draft: 'DRAFT',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE',
        DraftPublished: 'DRAFT_PUBLISHED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


